import * as types from "../actions/ActionTypes"
import initialState from "./initialState";

export default function (state = initialState.panel, action) {
    switch (action.type) {
        case types.SET_PANEL:
            return {...action.payload};
        default:
            return state;
    }

}